import LazyLoad from 'react-lazyload';
import React from 'react';

interface LazyLoadBlockProps {
    isLazyLoad: boolean;
    children: React.ReactNode;
    className?: string;
}

export const LazyLoadBlock: React.FC<LazyLoadBlockProps> = ({children, isLazyLoad, className}) => {
    return isLazyLoad ? (
        <LazyLoad height={200} offset={100} className={className}>
            {children}
        </LazyLoad>
    ) : (
        <>{children}</>
    );
};
